import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const ClosingMonthsViewChunk = lazy(() =>
  import('../feature-sets/ClosingMonthsView').then(({ ClosingMonthsView }) => ({
    default: ClosingMonthsView,
  }))
)

export const ClosingMonthsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.closingMonthsPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.closingMonthsPageTitle),
        },
      ]}
    >
      <ClosingMonthsViewChunk />
    </Page>
  )
}
